<template>
  <order-form v-if="order"
    @submit="submit"
    :init-order="order"
    :val-errors="valErrors"
    :settings="settings"
    submit-text="Speichern"
  />
</template>

<script>
import OrderForm from './order-form'

export default {
  components: { OrderForm },
  data () {
    return {
      valErrors: [],
      order: null,
      setttings: null
    }
  },
  methods: {
    async submit (order) {
      await this.initCsrf()

      this.valErrors = []
      this.$http.put(`/orders/${order.id}`, order).then(({ data }) => {
        this.$notify({
          message: 'Bestellung erfolgreich bearbeitet.',
          type: 'success'
        })
        this.redirectBack('/orders')
      }).catch(({ response }) => { this.valErrors = response.data.errors })
    }
  },
  created () {
    const settingsResponse = this.$http.get('/settings').then(({ data }) => {
          this.settings = data
          this.$http.get(`/orders/${this.$route.params.id}`).then(({ data }) => {
            data.products = data.products.map(product => {
              return {
                product: {
                  product,
                  price: product.pivot.price
                },
                quantity: product.pivot.quantity,
                referenznummer: product.pivot.referenznummer
              }
            })
            this.order = data
          })
        })
  }
}
</script>

<style>
</style>
